export enum ClientType {
  STANDARD = 'STANDARD',
  ENTERPRISE = 'ENTERPRISE'
}
